/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import * as React from 'react';

import BaseComponent from '@tock/shared/components/BaseComponent';
import LoadingBar from '@tock/shared/components/LoadingBar';

interface Props {
  children?: React.ReactNode;
  containerClassName?: string;
  isLoading?: boolean;
  spinnerClassName?: string;
  spinnerText?: string;
}

class LoadingBarContainer extends BaseComponent<Props> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static defaultProps: any;

  render() {
    const { children, containerClassName, isLoading, spinnerClassName, spinnerText } = this.props;

    return (
      <div className={containerClassName}>
        {isLoading && <LoadingBar contextClassName={spinnerClassName} text={spinnerText} />}

        {!isLoading && children}
      </div>
    );
  }
}

LoadingBarContainer.defaultProps = {
  isLoading: false,
};

export default LoadingBarContainer;
